import { createContext, useContext } from 'react';
import { NotificationIconState } from '../containers/navigation/states/NotificationIconState';

export const NotificationIconContext: React.Context<NotificationIconState> = createContext<NotificationIconState>(
    new NotificationIconState()
);

export const useNotificationIconState = (): NotificationIconState => {
    return useContext(NotificationIconContext);
};
